import React, { Component } from 'react';

class IconRelatedTicket extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="25.477" height="16.984" viewBox="0 0 25.477 16.984">
                <path id="Icon_awesome-ticket-alt" data-name="Icon awesome-ticket-alt" d="M5.661,8.746H19.815v8.492H5.661Zm17.692,4.246a2.123,2.123,0,0,0,2.123,2.123v4.246a2.123,2.123,0,0,1-2.123,2.123H2.123A2.123,2.123,0,0,1,0,19.361V15.115a2.123,2.123,0,0,0,0-4.246V6.623A2.123,2.123,0,0,1,2.123,4.5h21.23a2.123,2.123,0,0,1,2.123,2.123v4.246A2.123,2.123,0,0,0,23.354,12.992Zm-2.123-4.6a1.062,1.062,0,0,0-1.062-1.062H5.308A1.062,1.062,0,0,0,4.246,8.392v9.2a1.062,1.062,0,0,0,1.062,1.062H20.169a1.062,1.062,0,0,0,1.062-1.062Z" transform="translate(0 -4.5)" fill="#21436e" />
            </svg>
        );
    }
}

export default IconRelatedTicket;